import './Skills.css';
import {
  SiSharp, SiDotnet, SiSupabase, SiAngular, SiTypescript,
  SiReactivex, SiMaterialdesign, SiGit,
} from 'react-icons/si';

// Skills with an official brand logo use a Simple Icons component (`Icon`).
// Microsoft-brand tech (Azure, SQL Server, Visual Studio, Cosmos DB) and
// non-brand/conceptual items fall back to a Tabler webfont class (`icon`).
const GROUPS = [
  {
    icon: 'ti-server', label: 'Backend & Cloud',
    skills: [
      { Icon: SiSharp, name: 'C#', hot: true },
      { Icon: SiDotnet, name: 'ASP.NET Core', hot: true },
      { icon: 'ti-bolt', name: 'Azure Functions', hot: true },
      { Icon: SiDotnet, name: '.NET Framework', hot: false },
      { icon: 'ti-webhook', name: 'Web API', hot: false },
      { Icon: SiSupabase, name: 'Supabase Edge Fn', hot: false },
    ],
  },
  {
    icon: 'ti-browser', label: 'Frontend',
    skills: [
      { Icon: SiAngular, name: 'Angular 21', hot: true },
      { Icon: SiTypescript, name: 'TypeScript', hot: true },
      { Icon: SiReactivex, name: 'RxJS', hot: true },
      { Icon: SiMaterialdesign, name: 'Angular Material', hot: false },
    ],
  },
  {
    icon: 'ti-brand-azure', label: 'Azure Services',
    skills: [
      { icon: 'ti-transfer', name: 'Data Factory', hot: true },
      { icon: 'ti-shield', name: 'API Management', hot: true },
      { icon: 'ti-messages', name: 'Service Bus', hot: false },
      { icon: 'ti-sitemap', name: 'Logic Apps', hot: false },
      { icon: 'ti-bucket', name: 'Blob Storage', hot: false },
      { icon: 'ti-apps', name: 'App Services', hot: false },
    ],
  },
  {
    icon: 'ti-database', label: 'Databases',
    skills: [
      { icon: 'ti-database', name: 'SQL Server', hot: true },
      { Icon: SiSupabase, name: 'Supabase', hot: true },
      { icon: 'ti-planet', name: 'Cosmos DB', hot: false },
    ],
  },
  {
    icon: 'ti-robot', label: 'AI',
    skills: [
      { icon: 'ti-brain', name: 'Cursor IDE', hot: true },
      { icon: 'ti-brain', name: 'Claude Code', hot: true },
      { icon: 'ti-plug', name: 'MCP', hot: true },
      { icon: 'ti-sparkles', name: 'Vibe Coding', hot: true },
      { icon: 'ti-list-check', name: 'Cursor Rules', hot: false },
    ],
  },
  {
    icon: 'ti-robot', label: 'Dev Tools',
    skills: [
      { icon: 'ti-brand-visual-studio', name: 'Visual Studio', hot: false },
      { icon: 'ti-brand-vscode', name: 'VS Code', hot: false },
      { icon: 'ti-brand-azure', name: 'Azure DevOps', hot: false },
      { Icon: SiGit, name: 'Git', hot: false },
    ],
  },
  {
    icon: 'ti-topology-star', label: 'Architecture',
    skills: [
      { icon: 'ti-components', name: 'Microservices', hot: true },
      { icon: 'ti-hierarchy', name: 'SOA', hot: false },
      { icon: 'ti-stack', name: 'N-Tier', hot: false },
    ],
  },
];

export default function Skills() {
  return (
    <section id="skills" className="section-wrap">
      <div className="eyebrow-row">
        <div className="eyebrow-line" /><div className="eyebrow-txt">Technical Skills</div><div className="eyebrow-line" />
      </div>

      {GROUPS.map(g => (
        <div key={g.label} className="skill-group">
          <div className="group-header">
            <i className={`ti ${g.icon} group-icon`} />
            <span className="group-title">{g.label}</span>
            <div className="group-line" />
          </div>
          <div className="skills-grid">
            {g.skills.map(s => (
              <div key={s.name} className={`skill-card ${s.hot ? 'hot' : ''}`}>
                {s.hot && <div className="hot-dot" />}
                {s.Icon
                  ? <s.Icon className="skill-icon" />
                  : <i className={`ti ${s.icon} skill-icon`} />}
                <span className="skill-name">{s.name}</span>
              </div>
            ))}
          </div>
        </div>
      ))}

      <div className="skills-legend">
        <div className="legend-item"><div className="legend-dot accent" /><span>Primary expertise</span></div>
        <div className="legend-item"><div className="legend-dot muted" /><span>Proficient</span></div>
      </div>
    </section>
  );
}
